var scope_0 = require('/Users/ortiz/Sites/ortizluis/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48df62df3c5c5a0e29c3a71879cf8c37.js').default;export default
        Object.assign({}, scope_0 )
    